import { Box, Container, Flex, Grid, Heading } from "@radix-ui/themes";
import { FC } from "react";
import PrecisionGameUIWinners from "./precision.game.ui.winners";
import PrecisionGameUIMentions from "./precision.game.ui.mentions";
import DateObject from "react-date-object";
import { ReactComponent as IconElgiganten } from "branchAndBrandSpecific/utils/brandVariables/assets/elgiganten/elgiganten.svg";
import { ReactComponent as IconScanCode } from "../assets/scanThisCodeVertical.svg";
import QRCodeScan from "../assets/qr-code_signup.svg";

const PrecisionGameUIVertical: FC = (): JSX.Element => {
  const timestamp = new DateObject().format("YYYY-MM-DD");

  return (
    <Container size="3" py="5">
      <Flex direction="column" justify="between">
        <Flex justify="center">
          <Box maxWidth="50vw" pt="5">
            <IconElgiganten width="100%" height="auto" />
          </Box>
        </Flex>
        <Flex gap="9" direction="column">
          <Box>
            <Heading as="h1" size="9" align="center" mb="0">
              Stop the timer at 1337
            </Heading>
          </Box>
          <Box>
            <PrecisionGameUIWinners
              collection={timestamp}
              orientation="vertical"
            />
          </Box>
          <Flex gap="5" align="center" justify="center">
            <img src={QRCodeScan} alt="QR Code" width={175} height={175} />
            <IconScanCode />
          </Flex>
          <Box>
            <PrecisionGameUIMentions
              collection={timestamp}
              orientation="vertical"
            />
          </Box>
        </Flex>
      </Flex>
    </Container>
  );
};

export default PrecisionGameUIVertical;
